/* eslint-disable consistent-return */
import React from 'react';
import moment, { duration } from 'moment';
import PropTypes from 'prop-types';
import {
  locationIcon,
  hours,
  buddy,
} from 'assets/icons';
import styles from './styles.module.css';


export const CalendarCard = ({
  groupEx,
}) => {
  const {
    classInfo,
    startTime,
    endTime,
    date,
    trainerName,
    isLive,
    isVirtual,
  } = groupEx;

  const { club, name, programName } = classInfo;

  const calculateDuration = () => {
    const classDuration = duration(
      moment(`${date} ${endTime}`).valueOf() - moment(`${date} ${startTime}`).valueOf()
    );
    return `(${classDuration.hours() * 60 + classDuration.minutes()}min)`;
  };

  return (
    <div
      className={styles.cardContainer}
    >
      <div className={styles.mainContent}>
        <div className={styles.cardTitleWrapper}>
          <p className={styles.classTitle}>
            <span>{programName || name}</span>
            {(isLive || isVirtual) && <span className={styles.label}>Watch Live!</span>}
          </p>
        </div>

        <span className={styles.classTime}>
          <img className={styles.hoursIcon} src={hours} alt="hours" />
          {moment(`${date} ${startTime}`).format('h:mma')} {calculateDuration()}
        </span>

        <span className={styles.classExtraText}>
          <img className={styles.additionalInfoIcon} src={locationIcon} alt="location" />
          {club.name}
        </span>

        <span className={styles.classExtraText}>
          {trainerName && (
            <img
              className={[styles.additionalInfoIcon, styles.instructorIcon].join(' ')}
              src={buddy}
              alt="instructor"
            />
          )}
          {trainerName}
        </span>
      </div>
    </div>
  );
};

CalendarCard.propTypes = {
  groupEx: PropTypes.object.isRequired,
};
